import React from 'react';
interface TextInputProps {
  name: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  tooltip?: React.ReactNode;
  placeholder?: string;
  type?: 'text' | 'number';
}
export function TextInput({
  name,
  label,
  value,
  onChange,
  required,
  tooltip,
  placeholder,
  type = 'text'
}: TextInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };
  return <div className="space-y-2" data-id="element-344">
      <label htmlFor={name} className="flex items-center text-base font-medium text-gray-900" data-id="element-345">
        {label}
        {required && <span className="text-red-600 ml-1" data-id="element-346">*</span>}
        {tooltip}
      </label>
      <input id={name} name={name} type={type} value={value} onChange={handleChange} placeholder={placeholder} className="w-full px-4 py-3 border border-gray-300 bg-white hover:border-yellow-500 hover:shadow-[0_0_8px_rgba(234,179,8,0.4)] focus:border-yellow-500 focus:ring-2 focus:ring-yellow-500 focus:shadow-[0_0_12px_rgba(234,179,8,0.5)] focus:outline-none transition-all duration-300" data-id="element-347" />
    </div>;
}